module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	fox.registerWidget('Splash', {

		configure: function (options) {
			this.registerOptions('', {
				'embed.container': '.wrapper',
				'embed.location': 'under', // this location for SEO
				template: 'layout_splash',
				autoRender: true,
				active: true,
				group: 'splash',
				widgets: {
					splashBody: {
						widget: 'Widget',
						autoRender: true,
						'embed.container': '#container',
						template: 'sitepage_splash',
						'handleDom.enterSite': {
							event: 'click',
							target: '.enter',
							callback: this.enterSite.bind(this)
						},
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function() {
			this.callParent('activate', arguments);
			this.toggleOverflow(true);
		},

		deactivate: function() {
			this.callParent('deactivate', arguments);
			this.toggleOverflow();
		},

		toggleOverflow: function(hidden) {
			$('html').css('overflow', hidden ? 'hidden' : '');
		},

		enterSite: function () {
			var retUrl = fox.Navigator.get(0);
			var video = $('video')[0];
			var autoPlay = Number(fox.site.environment.siteProps.welcomeVideoAutoplay);

			fox.cookie.set('splash', 1);
			fox.site.showSplash = false;

			if (!!video && !!autoPlay) {
				video.play();
			}
			
			if(fox.Navigator.get(0) == 'splash'){
				fox.site.gotoPage('', { skipEvent: true });
			}
			
			$('#splash').remove();
			this.toggleOverflow();
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/splash/widget/splash.js
// module id = 517
// module chunks = 4